import '#core/application/modules/tiles/event-card-badge/index.js';

import {registerTileSchema} from '#core/application/schema-registry.js';

import {AbstractVisualFeature} from '#core/application/modules/visual-feature.js';

import {AvantgardeCards} from '../avantgarde-cards.js';

import {avantgardeBannerCardsFactory} from './avantgarde-banner-cards.factory.js';

import AVANTGARDE_BANNER_CARD_DETAILS from './avantgarde-banner-card-details.palette-schema.yaml';
import PALETTE_SCHEMA from './avantgarde-banner-cards.palette-schema.yaml';

registerTileSchema(AVANTGARDE_BANNER_CARD_DETAILS);

class AvantgardeBannerCardsFeature extends AbstractVisualFeature {
    get name() {
        return 'AvantgardeBannerCards';
    }

    get paletteSchema() {
        return PALETTE_SCHEMA;
    }

    getSerializableVisualConfig(PALETTE) {
        return avantgardeBannerCardsFactory(PALETTE);
    }
}

new AvantgardeBannerCardsFeature(AvantgardeCards);
